import { isDate } from 'date-fns'
import mapResponseToDictionary from './mappers/mapResponseToDictionary'

export default function fetchPaymentDictionaries(api: GlobalFetch) {
  return async function(modifyDate?: Date) {
    const d: number = isDate(modifyDate)
      ? Math.floor(modifyDate.getTime() / 1000)
      : 0

    const buildUrl = `/api/v2/typeofpaymentdictionary/index/modify_date/${d}`
    const response = await api.fetch(buildUrl)
    const responseBody: IData = await response.json()

    return mapResponseToDictionary(responseBody)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

interface IItemData {
  id: string
  id_user: string
  name: string
  deleted: '0' | '1'
  create_date: string
  modify_date: string
}
